import { adsSelectors } from 'ducks/ads'
import { AdPlacementCode } from 'elements/ads/AdPlacements'
import useAdStructs, { BannerConfig } from 'elements/ads/useAdStructs'
import BannerAd, { filterAvailableAds } from 'elements/BannerAd'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'

// TODO: further refactor BannerAd
// Create single source of truth that a ad banner would show
const useAdBanner = ({
  formats,
  placement,
  requiredWindowSize,
}: {
  formats: string[]
  placement: AdPlacementCode | undefined
  requiredWindowSize?: Record<string, { width?: number; height?: number }>
}) => {
  const promoConfigs = useAdStructs<BannerConfig>('banner-ad')
  const availableAds = placement ? filterAvailableAds(promoConfigs, { formats, placement }) : []
  const enableAdsFeatureFlag = useFeatureFlag('ads', 'on')
  const enableAds2FeatureFlag = useFeatureFlag('ads2', 'on')
  const enableAdsForOrg = useSelector(adsSelectors.getEnableAdsForOrg)
  const enableAds = enableAdsFeatureFlag && enableAdsForOrg
  const enableAds2 = enableAds2FeatureFlag && enableAdsForOrg
  if (placement && (enableAds2 || (enableAds && availableAds && availableAds.length > 0))) {
    return <BannerAd formats={formats} placement={placement} requiredWindowSize={requiredWindowSize} />
  }
  return null
}

export default useAdBanner
